module.exports = {
  latlng: [51.44826, 7.00622],
  zoom: 14,
  title: 'Das Ruhrgebiet als Häusermeer',
  introtext:'Wie gut kennen Sie sich im Ruhrgebiet wirklich aus? Erkennen Sie Orte der Region anhand der Gebäudeumrisse? Machen Sie das Häuserquiz und ordnen Sie den neun Häuserkarten die richtigen Orte zu. Zu jedem Ausschnitt gibt es einen kleinen Tipp.',
  resultSentences: [
    'Sie waren höchstens mal auf der Durchfahrt im Ruhrgebiet.',
    'Tourist? Beruflich unterwegs? Sie leben bestimmt nicht hier.',
    'Immerhin kennen Sie ein paar Ecken im Ruhrgebiet.',
    'Nicht schlecht. Sie kennen sich aus im Ruhrgebiet.',
    'Wow! Alles richtig. Sie sind wirklich ein Experte für das Ruhrgebiet.'
  ],
  questions: [
    {
      id: 'WAZ 1',
      lat: 51.4439146,
      lng: 7.2615507,
      zoom: 14,
      answers: [
        'Universität Duisburg-Essen',
        'TU Dortmund',
        'Ruhr-Uni Bochum'
      ],
      correctAnswer: 'Ruhr-Uni Bochum',
      description: 'Das Siegel dieser Hochschule zeigt Prometheus und Epimetheus.'
    },
    {
      id: 'WAZ 2',
      lat: 51.447531,
      lng: 6.7361191,
      zoom: 14,
      answers: [
        'Rhein-Ruhrmündung Duisburg',
        'Ruhrstrand Mülheim a.d. Ruhr',
        'Wassergewinnung Essen'
      ],
      correctAnswer: 'Rhein-Ruhrmündung Duisburg',
      description: 'Hier endet der 230 Kilometer lange Ruhrtal-Radweg.'
    },
    {
      id: 'WAZ 3',
      lat: 51.4360452,
      lng: 6.8077419,
      zoom: 15,
      answers: [
        'Dortmunder Zoo',
        'Tierpark Bochum',
        'Zoo Duisburg'
      ],
      correctAnswer: 'Zoo Duisburg',
      description: 'Bekannt für Koalazucht und das Delfinarium.'
    },
    {
      id: 'WAZ 4',
      lat: 51.4920833,
      lng: 7.4534373,
      zoom: 14,
      answers: [
        'Benteler Arena',
        'Signal-Iduna-Park',
        'Vonovia Ruhrstadion'
      ],
      correctAnswer: 'Signal-Iduna-Park',
      description: 'Hier verlor Deutschland bei der Heim-WM 2006 gegen Italien.'
    },
    {
      id: 'WAZ 5',
      lat: 51.4325388,
      lng: 6.9767228,
      zoom: 14,
      answers: [
        'Margarethenhöhe Essen',
        'Dahlhauser Heide Bochum',
        'Gartenstadt Dortmund'
      ],
      correctAnswer: 'Margarethenhöhe Essen',
      description: 'Dieses Viertel gilt als erste deutsche Gartenstadt.'
    },
    {
      id: 'WAZ 6',
      lat: 51.4900844,
      lng: 6.8788536,
      zoom: 14,
      answers: [
        'Thier-Galerie Dortmund',
        'Centro Oberhausen',
        'Forum Duisburg'
      ],
      correctAnswer: 'Centro Oberhausen',
      description: 'Hier befindet sich einer der größten Food-Courts Europas.'
    },
    {
      id: 'WAZ 7',
      lat: 51.4068702,
      lng: 7.0087958,
      zoom: 16,
      answers: [
        'Villa Hügel',
        'Burg Altendorf',
        'Rittergut Haus Laer'
      ],
      correctAnswer: 'Villa Hügel',
      description: 'Hier hat die Kulturstiftung Ruhr ihren Sitz.'
    },
    {
      id: 'WAZ 8',
      lat: 51.486438,
      lng: 7.4842475,
      zoom: 13,
      answers: [
        'Zeche Zollverein Essen',
        'Landschaftspark Duisburg-Nord',
        'Phönix-West Dortmund'
      ],
      correctAnswer: 'Phönix-West Dortmund',
      description: 'Bis 2013 fand hier das Rockmusik-Festival Rock in den Ruinen statt.'
    },
    {
      id: 'WAZ 9',
      lat: 51.5536843,
      lng: 7.0665073,
      zoom: 14,
      answers: [
        'SchücoArena',
        'Veltins-Arena',
        'Vonovia Ruhrstadion'
      ],
      correctAnswer: 'Veltins-Arena',
      description: 'Der Rasen kann auf Schienen aus dem Stadion gefahren werden.'
    },
    {
      id: 'WAZ 10',
      lat: 51.4275797,
      lng: 6.8763069,
      zoom: 14,
      answers: [
        'Ruhrpromenade Mülheim',
        'Ruhrpromenade Essen-Steele',
        'Ruhrmündung Duisburg'
      ],
      correctAnswer: 'Ruhrpromenade Mülheim',
      description: 'Dieser Spazierweg liegt am Ruhrkilometer 12.'
    }
  ]
}